import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import PeopleIcon from "@mui/icons-material/People";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import EngineeringIcon from "@mui/icons-material/Engineering";
import MoreTimeIcon from "@mui/icons-material/MoreTime";

export const iconsMap: Record<string, React.ElementType> = {
  GpsFixedIcon,
  EqualizerIcon,
  PeopleIcon,
  TrendingUpIcon,
  PrecisionManufacturingIcon,
  EmojiEventsIcon,
  PersonOffIcon,
  TrendingDownIcon,
  EngineeringIcon,
  MoreTimeIcon,
  CheckCircleIcon, // fallback
};
